var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m_header"},[(_vm.showLeft)?_c('i',{staticClass:"iconfont icon-jiantou-copy",on:{"click":_vm.back}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.title))]),(_vm.showRight)?_c('i',{staticClass:"iconfont icon-jiantou"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }